import "./App.css";
import logo from "./images/cosi-logo.png";
import grabAndGo from "./images/g.webp"; // Updated path

function App() {
  return (
    <div className="App">
      <header className="Header">
        <img src={logo} alt="Cosi Logo" className="Header-logo" />
        <h1 className="Header-title">Fresh, Healthy, Daily Delivery</h1>
        <p>
          KDO Enterprises, a NYC minority certified franchisee, has partnered
          with Così for fresh food delivery to transportation centers.
        </p>
      </header>

      <svg
        className="CurvyBorder"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="#fff8f0"
          fillOpacity="1"
          d="M0,192L48,160C96,128,192,64,288,64C384,64,480,128,576,160C672,192,768,192,864,160C960,128,1056,64,1152,64C1248,64,1344,128,1392,160L1440,192L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
        ></path>
      </svg>

      <section className="Content">
        <img
          src={grabAndGo}
          alt="Cosi Grab and Go Display"
          className="Content-image"
          style={{ width: "80%", marginTop: "-20px" }} // Adjusted margin to push the image up
        />
        <h2>Why Choose Così Grab and Go?</h2>
        <p>Daily fresh delivery of muffins, wraps, salads, and sandwiches.</p>
        <p>Top 25 most loyal customer base nationwide.</p>
        <p>
          Available in key transportation centers: Logan, LaGuardia, and more.
        </p>
      </section>

      <svg
        className="CurvyBorder"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="#fff8f0"
          fillOpacity="1"
          d="M0,128L48,160C96,192,192,256,288,256C384,256,480,192,576,160C672,128,768,128,864,160C960,192,1056,256,1152,256C1248,256,1344,192,1392,160L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg>

      <section className="Contact">
        <h2>Contact Us</h2>
        <p>
          Mike Onghai: <a href="tel:6467093731">(646) 709-3731</a>
        </p>
        <p>
          Kesav Dama: <a href="tel:5167129200">(516) 712-9200</a>
        </p>
        <p>
          Vijay Janki: <a href="tel:5164265937">(516) 426-5937</a>
        </p>
      </section>

      <footer className="Footer">
        <img src={logo} alt="Cosi Grab and Go" className="Footer-image" />
        <p>© 2023 Così Grab and Go. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default App;
